export enum BGChartType{
    None = 0,
    Main = 1,
    Info = 2,
    Summary = 3,
    InfoPanel = 4,
    MainChart = 5,
    BubbleChart = 6,
    SummaryLineChart = 7,
    CompareChart = 8,
    All = 9
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/b-g-chart-type.ts